/* import __COLOCATED_TEMPLATE__ from './trash-can.hbs.js'; */
import Component from '@glimmer/component';
export default class TrashCan extends Component {
  get fill() {
    return this.args.fill ?? 'var(--core-text-10-light-mode-color)';
  }
  get fillOpacity() {
    return this.args.fillOpacity ?? '0.3';
  }
}